import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaBookOpen,
  FaClock,
  FaUserGraduate,
  FaLaptopCode,
  FaChalkboardTeacher,
  FaCheckCircle,
} from "react-icons/fa";

const ExamSelection = () => {
  const navigate = useNavigate();

  const iconColorMap = {
    FaBookOpen: "text-blue-500",
    FaClock: "text-teal-500",
    FaCheckCircle: "text-green-500",
    FaChalkboardTeacher: "text-purple-500",
    FaLaptopCode: "text-orange-500",
    FaUserGraduate: "text-yellow-500",
  };

  const packages = [
    {
      title: "Opportunity Class (OC)",
      subtitle: "Year 4 Entry Preparation",
      description: "For students preparing for Opportunity Class placement tests",
      points: [
        { icon: <FaBookOpen className={iconColorMap["FaBookOpen"]} />, text: "English, Mathematical Reasoning, Thinking Skills" },
        { icon: <FaClock className={iconColorMap["FaClock"]} />, text: "10 questions in each section" },
        { icon: <FaCheckCircle className={iconColorMap["FaCheckCircle"]} />, text: "Immediate feedback" },
      ],
      color: "from-purple-500 to-teal-400",
      shadow: "shadow-purple-300",
      badge: "bg-purple-100 text-purple-700",
      examType: "oc"
    },
    {
      title: "Selective High School",
      subtitle: "Year 6 Entry Preparation",
      description: "For students aiming for Selective High School entry",
      points: [
        { icon: <FaUserGraduate className={iconColorMap["FaUserGraduate"]} />, text: "Reading, Mathematical Reasoning" },
        { icon: <FaClock className={iconColorMap["FaClock"]} />, text: "Thinking Skills assessment" },
        { icon: <FaCheckCircle className={iconColorMap["FaCheckCircle"]} />, text: "Detailed performance analysis" },
      ],
      color: "from-orange-500 to-blue-400",
      shadow: "shadow-orange-300",
      badge: "bg-orange-100 text-orange-700",
      examType: "selective"
    },
  ];

  const handleSelect = (examType) => {
    localStorage.setItem("examType", examType);
    navigate("/freeassesment");
  };

  return (
    <div className="bg-teal-50 min-h-screen py-10 sm:py-16 md:py-20 px-4 sm:px-6 md:px-10">
      <div className="max-w-3xl mx-auto text-center mb-8 sm:mb-12 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-800 mb-2 sm:mb-4">
          Choose Your Assessment
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-gray-600">
          Select the test type to begin your free assessment
        </p>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-10">
        {packages.map((pkg, index) => (
          <div
            key={index}
            className={`relative p-[2px] rounded-2xl sm:rounded-3xl bg-gradient-to-br ${pkg.color} ${pkg.shadow} hover:shadow-lg sm:hover:shadow-2xl transition cursor-pointer`}
            onClick={() => handleSelect(pkg.examType)}
          >
            <div className="bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-6 md:p-8 h-full">
              <div className={`inline-block px-3 py-1 text-xs sm:text-sm rounded-full font-semibold mb-3 sm:mb-4 ${pkg.badge}`}>
                {pkg.subtitle}
              </div>
              <h3 className="text-xl sm:text-2xl font-extrabold text-gray-900">{pkg.title}</h3>
              <p className="text-xs sm:text-sm text-gray-600 mt-1 sm:mt-2 mb-4 sm:mb-6">{pkg.description}</p>

              <ul className="space-y-3 sm:space-y-4 border-l-4 border-teal-400 pl-4 sm:pl-6">
                {pkg.points.map((point, idx) => (
                  <li key={idx} className="flex items-start gap-2 sm:gap-3">
                    <span className="mt-0.5 sm:mt-1">{point.icon}</span>
                    <p className="text-gray-800 text-sm sm:text-base">{point.text}</p>
                  </li>
                ))}
              </ul>

              <button className="mt-6 sm:mt-8 w-full rounded-full px-4 py-2 sm:px-6 sm:py-3 text-sm sm:text-md font-semibold bg-teal-500 text-white shadow-md hover:bg-teal-600 transition duration-300">
                Select This Assessment
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExamSelection;